import {
    CREATE_COMMISSIONS_FAILURE,
    FETCH_COMMISSION_SUCCESS,
    FETCH_COMMISSIONS_SUCCESS,
    SELECT_COMMISSION,
    COMMISSION_UPDATE
} from "./actions";

const initialState = {
    currently_loading_commissions: false,
    commissions_in_current_page: [],
    current_page: 0,
    total_commissions: 0,
    total_pages: 0,
    new_commission_error: null,
    new_commission_request: {
        commission_name: null,
        ticker: null,
        start_date: null,
        end_date: null,
        corrective_events: []
    },
    selected_commission: {}
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COMMISSIONS_SUCCESS:
            return {
                ...state,
                current_page: action.page,
                commissions_in_current_page: action.data,
                total_pages: action.total_pages
            };
        case SELECT_COMMISSION:
            return {...state, selected_commission: {id: action.id}};
        case FETCH_COMMISSION_SUCCESS:
            let response = action.data;
            return {
                ...state, selected_commission: {
                    id: action.id,
                    classPeriodStart: response.classPeriodStart,
                    classPeriodEnd: response.classPeriodEnd,
                    dateCommissioned: response.dateCommissioned,
                    lastUpdate: response.lastUpdate,
                    commissionName: response.commissionName,
                    symbol: response.symbol,
                    status: response.status,
                    classPeriodTradingStats: response.classPeriodTradingStats,
                    marketCapitalizationLosses: response.marketCapitalizationLosses,
                    statResidualReturns: response.statResidualReturns,
                    stockPrices: response.stockPrices,
                    dollarValueInflations: response.dollarValueInflations,
                    aggregateDamages: response.aggregateDamages,
                    correctiveEvents: response.correctiveEvents,
                }
            };
        case CREATE_COMMISSIONS_FAILURE:
            return {
                ...state,
                new_commission_error: action.error
            };

        case COMMISSION_UPDATE:
            return {
                ...state,
                UpdateCommissionResult: action.UpdateCommissionResult
            };
        default:
            return state
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/commissions/redux/reducers.js